<template>
    <a
        :class="{ 'l-ss-c-completions-item-is-active': isActive, 'l-ss-c-completions-item-is-current': (data.active === 1), [`l-ss-c-completions-item-type-${labelToken}`]: Boolean(labelToken) }"
        :href="data.url"
        :target="$configuration.linkTargetBlank ? '_blank': '_self'"
        class="l-ss-c-completions-item">
        <div
            class="l-ss-c-completions-item-content">
            <div
                v-if="showImage"
                class="l-ss-c-completions-item-thumbnail-wrapper">
                <span class="l-ss-c-completions-item-thumbnail">
                    <i
                        :class="{ 'l-ss-c-completions-item-thumbnail-stub-is-active': !isActiveImageLoaded || isActiveImageError }"
                        class="l-ss-c-completions-item-thumbnail-stub"
                        v-html="noPhotoIcon"></i>
                    <img
                        v-show="isActiveImageLoaded && !isActiveImageError"
                        :src="imageUrlValue"
                        alt="product"
                        class="l-ss-c-completions-item-thumbnail-image"
                        @error="handleImageError"
                        @load="handleImageLoad">
                </span>
            </div>
            <div class="l-ss-c-completions-item-main-data">
                <div class="l-ss-c-completions-item-title-wrapper">
                    <span
                        v-if="isCatPrefixActive && textPrefix"
                        class="l-ss-c-completions-item-prefix">
                        <span
                            class="l-ss-c-completions-item-prefix-value"
                            v-html="textPrefix">
                        </span>
                    </span>
                    <span
                        class="l-ss-c-completions-item-title"
                        v-html="textLabel || textValue"></span>
                    <i
                        v-if="data.label === 'history'"
                        class="l-ss-c-search-input-icon l-ss-c-search-hints-icon-remove"
                        v-html="iconDeleteQuery"
                        @click.stop="removeUserHint(data)"></i>
                    <span
                        v-if="data.count"
                        class="l-ss-c-completions-item-count l-ss-c-count-tag">{{ data.count }}</span>
                </div>
                <div class="l-ss-c-completions-item-caption-wrapper">
                    <span
                        v-if="data.offer_code"
                        class="l-ss-c-completions-item-caption">{{ $t('vendorCode') }}: {{ data.offer_code }}</span>
                    <span
                        v-if="data.snippet"
                        class="l-ss-c-completions-item-caption">
                        {{ data.snippet }}
                    </span>
                </div>
                <div
                    v-if="offerLabel"
                    :class="{ 'l-ss-c-offer-label-wrapper-full-width': $configuration.completionsFullWidth }"
                    class="l-ss-c-offer-label-wrapper">
                    <span class="l-ss-c-offer-label l-ss-c-offer-label-text">{{ offerLabel }}</span>
                </div>
                <span
                    v-if="annotation"
                    class="l-ss-c-completions-item-annotation">{{ annotation }}</span>
                <price
                    v-if="showPrices"
                    :offer="data"
                    class="l-ss-c-completions-item-prices-wrapper"/>
            </div>
            <div
                v-if="offerLabel"
                class="l-ss-c-completions-item-actions">
                <div
                    v-if="showCartButton"
                    class="l-ss-c-offer-footer-action-add-to-cart">
                </div>
            </div>
        </div>
        <div
            v-if="!offerLabel"
            class="l-ss-c-completions-item-actions">
            <button
                v-if="showCartButton"
                ref="add-cart-btn"
                class="l-ss-c-offer-footer-action-add-to-cart"
                type="button"
                @click.stop.prevent="addToCart(getOffer)"
                @touchstart.stop.prevent="addToCart(getOffer)">
                <i
                    class="l-ss-c-icon l-ss-c-icon-primary"
                    v-html="cartIcon"></i>
            </button>
            <span
                v-else-if="provision(labelToken)"
                class="l-ss-c-completions-item-label">
                {{ customLabel ? customLabel : $t(`completions.category.${labelToken}`) }}
            </span>
        </div>

    </a>
</template>

<script>
    import CartMixin from '../../mixins/cart-mixin';
    import noPhotoIcon from '../../assets/images/no-photo.svg';
    import { currencyAsString } from '../../helpers/display';
    import cartIcon from '../../../core/assets/images/icons/add-to-cart.svg';
    import delegateEvent from '../../helpers/delegate-event';
    import cutText from '../../helpers/cut-text';
    import iconDeleteQuery from '../../../core/assets/images/icons/delete.svg';
    import Price from '@/core/components/price';

    export default {
        components: {
            Price,
        },
        mixins: [
            CartMixin,
        ],
        props: {
            isActive: {
                type: Boolean,
                required: false,
                default: false,
            },
            isCartAvailable: {
                type: Boolean,
                default: false,
            },
            isCatPrefixActive: {
                type: Boolean,
                default: true,
            },
            data: { // Backend response completions item
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                isActiveImageError: false,
                isActiveImageLoaded: false,
            };
        },
        computed: {
            oldPrice() {
                return (this.data.old_price !== this.data.price) ? this.data.old_price : null;
            },
            showCartButton() {
                return (this.data.price || !!this.data.prices?.lenght) && this.labelToken === 'offers' && this.isCartAvailable;
            },
            cartIcon() {
                return cartIcon;
            },
            iconDeleteQuery() {
                return iconDeleteQuery;
            },
            showPrices() {
                return this.data.price || this.data.old_price || !!this.data.prices;
            },
            textPrefix() {
                if (!this.data.hierarchy) {
                    return '';
                }
                const textLength = this.textValue.length;
                const maxLengthMobile = 30;
                const maxLengthDesktop = 65;
                const minPrefixLength = 10;
                const prefixLength = this.data.hierarchy.length;

                let resLength = 0;

                if (this.$screen.isMobile) {
                    resLength = maxLengthMobile - textLength;
                } else {
                    resLength = maxLengthDesktop - textLength;
                }

                if ((resLength >= minPrefixLength) || (prefixLength <= minPrefixLength)) {
                    return this.data.hierarchy ? cutText(this.data.hierarchy ?? '', resLength) : '';
                }
                return '';
            },
            textLabel() {
                return this.data.text.html || this.data.text.label || '';
            },
            textValue() {
                return this.data.text.value || this.data.text.label || '';
            },
            customLabel() {
                return this.data.displayed_label || '';
            },
            urlValue() {
                return this.data.url;
            },
            imageUrlValue() {
                return this.data.image_url;
            },
            labelToken() {
                return this.data.label;
            },
            annotation() {
                return this.data.annotation;
            },
            hasUrl() {
                return !!this.data.url;
            },
            showImage() {
                return this.data.image_url || this.labelToken === 'offers';
            },
            noPhotoIcon() {
                return noPhotoIcon;
            },
            getOffer() {
                return {
                    id: this.data.id,
                    name: this.textLabel,
                    price: this.data.price || this.data.old_price,
                    quantity: this.quantity,
                    img: this.data.image_url,
                };
            },
            offerLabel() {
                if (this.data.offer.labels !== undefined) {
                    if (this.data.offer.labels.some(label => label.id === 'notAvailable')) {
                        let labelTitle = '';
                        this.data.offer.labels.forEach((label, index) => {
                            if (label.id === 'notAvailable') {
                                labelTitle = this.$t(`labels.${label.id}`, null, this.data.offer.labels[index].title);
                            }
                        });
                        return labelTitle;
                    }
                }
                return false;
            },
        },
        methods: {
            removeUserHint(data) {
                this.$emit('remove-history', data);
            },
            provision(labelToken) {
                return (labelToken && !this.$screen.isMobile && labelToken !== 'offers');
            },
            getPriceLabel(value) {
                return value ? currencyAsString(value, this.data.currency) : '';
            },
            handleImageError() {
                this.isActiveImageError = true;
            },
            handleImageLoad() {
                this.isActiveImageLoaded = true;
            },
            handleClick(event) {
                delegateEvent(event, {
                    addToCart: () => this.addToCart(this.getOffer),
                });
            },
        },
    };
</script>
<style>

</style>
